import React, { useEffect, useState } from "react";
import editIcon from "assets/edit_icon.png";
import { EditNodeProps, TriggerBaseProps } from "./TriggerBase.types";

export const EditNode: React.FC<EditNodeProps> = ({ setShowSelector }) => {
  return (
    <div className="EditNode" onClick={() => setShowSelector(true)}>
      <img src={editIcon} alt="Edit type" className="EditNodeIcon" />
    </div>
  );
};

const TriggerBase: React.FC<TriggerBaseProps> = ({
  title,
  setShowTriggerTypeSelector,
  workflowBuilderErrors,
  errorIndex = 0,
  children,
}) => {
  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);

  useEffect(() => {
    if (
      workflowBuilderErrors &&
      workflowBuilderErrors.trigger &&
      workflowBuilderErrors.trigger.hasOwnProperty(errorIndex)
    ) {
      const tempErrors = workflowBuilderErrors.trigger[errorIndex];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors, errorIndex]);

  return (
    <div
      className={`TriggerContainer DetailsItemContent${
        relevantErrors && relevantErrors.length > 0 ? " Error" : ""
      }`}
    >
      <label className="Title">
        <div className="Text">{`Trigger - ${title}`}</div>
        <EditNode setShowSelector={setShowTriggerTypeSelector} />
      </label>

      {children}

      {relevantErrors && relevantErrors.length > 0 && (
        <div className="Errors">
          {relevantErrors.map((error, idx) => (
            <div key={idx} className="Error">
              {error}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TriggerBase;
